module.exports = __webpack_public_path__ + "static/fonts/icomoon.7d4ac7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/wangEditorV2/fonts/icomoon.woff?-qdfu1s
// module id = 3555
// module chunks = 6